// extracted by mini-css-extract-plugin
module.exports = {"new":"index_new_17S5_","favorite":"index_favorite_2Be_E","thumb":"index_thumb_Fv9ck","image":"index_image_1uUAn"};